import * as $ from 'jquery';
import * as q from 'q';
import * as globalConfig from 'globalConfig';
import * as ko from 'knockout';

// Models
import { JoinMemberRequestModel } from 'Content/ts/Models/Join/JoinMemberRequestModel';
import { FacilityModel } from 'Content/ts/Models/Join/FacilityModel';
import { IJoinRequestResponseModel } from 'Content/ts/Models/Join/Interfaces/IJoinRequestResponseModel';
import { IJourneyContactField } from 'Content/ts/Models/Join/Interfaces/IJourneyContactField';
import { IMemberServiceModel } from 'Content/ts/Models/Join/Interfaces/IMemberServiceModel';
import { IAgreementModel } from 'Content/ts/Models/Join/AgreementModels';
import { IMembershipRequestModel } from 'Content/ts/Models/Join/Interfaces/IMembershipRequestModel';
import { FacilityHierarchyModel } from 'Content/ts/Models/Join/FacilityHierarchyModel';

class JoinService {
    // method to get the facility info
    getFacilityDetails(locationId: number): Q.Promise<FacilityModel> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.FacilityDetails.FacilityDetailsGetByLocationId + locationId
        }));
    };

    // method to get the agreements
    getAgreements(request: IMembershipRequestModel): Q.Promise<IAgreementModel[]> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.AgreementsForJourneyFacility,
            data: request
        }));
    };

    getMemberServices(request: IMembershipRequestModel): Q.Promise<IMemberServiceModel[]> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.JourneyMemberServices,
            data: request
        }));
    };

    getJourneyDetails(journeyId: number): Q.Promise<any> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.JourneyDetails + journeyId
        }));
    };

    getJourneyLocationAllocations(journeyId: number): Q.Promise<any[]> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.JourneyLocationAllocations + journeyId
        }));
    };

    getJourneyDefaultLocation(journeyId: number): Q.Promise<number> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.JourneyDefaultLocation + journeyId
        }));
    };

    getJourneyLocations(journeyId: number): Q.Promise<FacilityHierarchyModel[]> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.JourneyLocation + journeyId
        }));
    };

    getAssignedContactFields(journeyId: number): Q.Promise<IJourneyContactField[]> {
        return q($.ajax({
            type: 'GET',
            url: globalConfig.Urls.Join.JourneyAssignedContactFields + journeyId
        }));
    };

    addMembershipToBasket(request: JoinMemberRequestModel): Q.Promise<IJoinRequestResponseModel> {
        return q($.ajax({
            type: 'POST',
            url: globalConfig.Urls.Join.AddMembership,
            data: request
        }));
    };

    addNewActiveMembershipToBasket(request: JoinMemberRequestModel): Q.Promise<IJoinRequestResponseModel> {
        return q($.ajax({
            type: 'POST',
            url: globalConfig.Urls.Join.AddNewActiveMembership,
            data: request 
        }));
    };
}

var service = new JoinService();
export { service as JoinService };